import Stars from './Stars';
import './Stars.scss';

export default Stars;